import { useMemo, useState } from "react";
import { Page, Panel, Table, StatusPill, DeleteButton, SearchInput } from "../lib/ui";
import { money, can, rowLink } from "../lib/api";

export default function Records({ rows, setModal, onDelete, user }) {
  const [q, setQ] = useState("");
  const filtered = useMemo(() => rows.filter((r) => !q || r.title?.toLowerCase().includes(q.toLowerCase()) || r.category?.toLowerCase().includes(q.toLowerCase())), [rows, q]);
  const totals = useMemo(() => {
    const income = rows.filter((r) => r.type === "income").reduce((s, r) => s + r.amount, 0);
    const expense = rows.filter((r) => r.type === "expense").reduce((s, r) => s + r.amount, 0);
    return { income, expense };
  }, [rows]);

  return (
    <>
      <Page
        eyebrow="FİNANSPANEL · YÖNETİM"
        title="Gelir · Gider"
        subtitle="Tüm finansal hareketleri takip edin."
      />

      <div className="mini-stats">
        <div><span>Toplam gelir</span><strong className="positive">+{money(totals.income)}</strong></div>
        <div><span>Toplam gider</span><strong className="negative">-{money(totals.expense)}</strong></div>
        <div><span>Kayıt</span><strong>{rows.length}</strong></div>
      </div>

      <Panel
        className="module-panel"
        action={<SearchInput value={q} onChange={setQ} testid="records-search" placeholder="İşlem veya kategori ara" />}
      >
        <Table
          testid="records-table"
          columns={[
            { label: "İşlem" }, { label: "Kategori" }, { label: "Tarih" }, { label: "Durum" },
            { label: "Tutar", align: "right" }, { label: "" },
          ]}
          rows={filtered}
          empty="Henüz kayıt yok."
          renderRow={(r) => (
            <tr key={r.id} data-testid={`record-row-${r.id}`} className="clickable-row"
                {...rowLink(`/detay/kayit/${r.id}`)}
                style={{ cursor: "pointer" }}>
              <td><a href={`/detay/kayit/${r.id}`} className="row-anchor" onClick={(e) => e.stopPropagation()}><strong>{r.title}</strong></a><small>{r.type === "income" ? "Gelir" : "Gider"}</small></td>
              <td>{r.category}</td>
              <td>{r.date}</td>
              <td><StatusPill status={r.status} /></td>
              <td className={`amount ${r.type === "income" ? "positive" : "negative"}`}>
                {r.type === "income" ? "+" : "-"}{money(r.amount)}
              </td>
              <td className="amount" onClick={(e) => e.stopPropagation()}>
                <DeleteButton
                  testid={`delete-record-${r.id}`}
                  disabled={!can(user, r.type === "income" ? "delete_income" : "delete_expense")}
                  onClick={() => onDelete(r)}
                />
              </td>
            </tr>
          )}
        />
      </Panel>
    </>
  );
}
